(() => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = menu.hasAttribute('open');
      if (isOpen) menu.removeAttribute('open');
      else menu.setAttribute('open', '');
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const option = event.target.options[event.target.selectedIndex];
      const button = event.target.closest('form')?.querySelector('[data-add-button]');
      if (!button) return;
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    });
  });
})();
